import { useContext } from "react"

import { NotificationsContext } from "@providers/NotificationsProvider"

const useNotifications = () => {
  return useContext(NotificationsContext)
}

export default useNotifications
